module.exports = __webpack_public_path__ + "media/images/banner-fa41f279b756bb64add1194db624599a.jpeg";